import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Auth } from "aws-amplify";
import api from "../utils/useApi";
import { FunctionGetUsername } from "../utils/useFunction";

export const loginThunk = createAsyncThunk(
  "auth/token",
  async ({ username, password }) => {
    try {
      // const userSignIn = await Auth.signIn({
      //   username: `${FunctionGetUsername(username)}`,
      //   password: `${password}`,
      // });

      // if (userSignIn?.challengeName === "NEW_PASSWORD_REQUIRED") {
      //   await Auth.completeNewPassword(userSignIn, password);
      // }

      const phone_number = await username;

      localStorage.setItem("phone_number", phone_number);

      // console.log("LOGIN T", phone_number);

      const {
        data: { data },
      } = await api.post(`/profiles/login`, {
        phone_number: String(phone_number).startsWith("+")
          ? phone_number
          : `+${phone_number}`,
      });

      if (data?._id && data?.email && data?.full_name) {
        return { user: data };
      } else if (data?._id) {
        return { user: data, status: "non-complete" };
      } else {
        return { user: null };
      }
    } catch (error) {
      console.error("Auth error : ", error);
      // alert(error);

      return { user: null };
    }
  }
);

export const initAuth = createAsyncThunk(
  "initializeApp/initializeStore",
  async () => {
    try {
      // const userSignIn = await Auth.currentAuthenticatedUser();

      // const phone_number = await userSignIn.attributes.phone_number;

      const phone_number = localStorage.getItem("phone_number");
      if (phone_number) {
        const {
          data: { data },
        } = await api.post(`/profiles/login`, {
          phone_number: phone_number,
        });

        if (data?._id) {
          return { user: data };
        } else {
          return { user: null };
        }
      } else {
        return { user: null };
      }
    } catch (error) {
      return {
        user: null,
        status: "error",
      };
    }
  }
);

const initialState = {
  isLoggedIn: false,
  user: null,
  loading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: {
    [loginThunk.fulfilled]: (state, action) => {
      state.user = action.payload.user;
      state.isLoggedIn = true;
      state.loading = false;
    },
    [initAuth.fulfilled]: (state, action) => {
      state.user = action.payload.user;
      state.isLoggedIn = true;
      state.loading = false;
    },
    [loginThunk.pending]: (state, _) => {
      state.user = null;
      state.isLoggedIn = false;
      state.loading = true;
    },
  },
});

export default authSlice.reducer;
